<template>
    <v-layout class="consent-wrapper TextUnderCkBox" data-testid="phx-covid-screening-details-consent">
        <v-flex class="pa-2">
            <span
                class="hint"
                tabindex="0"
                aria-hidden="false"
                v-text="$t('form.phxCovidScreeningDetailsConsentHint')"
            />
            <ul
                class="list-items"
                tabindex="0"
                aria-hidden="false">
                <li>
                    <span
                        class="hint"
                        v-text="$t('form.phxCovidScreeningDetailsConsentPoint1')"
                    />
                </li>
                <li>
                    <span
                        class="hint"
                        v-text="$t('form.phxCovidScreeningDetailsConsentPoint2')"
                    />
                </li>
                <li>
                    <span
                        class="hint"
                        v-text="$t('form.phxCovidScreeningDetailsConsentPoint3')"
                    />
                </li>
            </ul>

            <metadata-checkbox
                :metadata="getMetadata"
                :value="value"
                :required="required"
                @update:value="emitValueCheckbox1" />

            <metadata-checkbox
                :metadata="getMetadata2"
                :value="value2"
                :required="required"
                @update:value="emitValueCheckbox2" />
        </v-flex>
    </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import { MetadataEnum } from '@/enums';
import { find, replace } from 'lodash';
import MetadataCheckbox from '@/components/metadata/inputs/checkbox/MetadataCheckbox.vue';

export default {
    components: {
        MetadataCheckbox
    },
    mixins: [formRules],
    props: {
        metadata: { type: Object, required: true },
        otherMetadata: { type: Array, required: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: Boolean, required: true },
    },
    data() {
        return {
            consentLink: 'https://static.trimoz.com/clicsante/documents/Consentement_limites_risques.pdf',
            value2: false
        };
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),
        getMetadata() {
            return {
                ...this.metadata,
                descriptionFr: this.$i18n.t('form.phxCovidScreeningDetailsConsentLabel'),
                descriptionEn: this.$i18n.t('form.phxCovidScreeningDetailsConsentLabel')
            };
        },
        getMetadata2() {
            return {
                ...this.metadata,
                descriptionFr: this.phxCovidAcceptRiskLabel,
                descriptionEn: this.phxCovidAcceptRiskLabel
            };
        },
        phxCovidAcceptRiskLabel() {
            return replace(this.$t('form.phxCovidAcceptRiskLabel'), /%consentDomain%/g, this.consentLink);
        },
        getStatusForAcceptRisk() {
            const acceptRisk = find(this.otherMetadata, ['metadata', MetadataEnum.PHX_COVID_ACCEPT_RISK]);
            if (acceptRisk) {
                return acceptRisk.status === 1;
            }
            return !!acceptRisk;
        },
    },
    methods: {
        emitValueCheckbox1(value) {
            this.$emit('updateOtherMetadata', {
                metadata: this.otherMetadata && find(this.otherMetadata, ['metadata', MetadataEnum.PHX_COVID_SCREENING_DETAILS_CONSENT]),
                value,
            });
        },
        emitValueCheckbox2(value) {
            this.value2 = value;
            this.$emit('updateOtherMetadata', {
                metadata: find(this.otherMetadata, ['metadata', MetadataEnum.PHX_COVID_ACCEPT_RISK]),
                value,
            });
        },
    },
};
</script>

<style scoped lang="scss">
.TextUnderCkBox {
  border: 2px solid var(--v-border-metadata-color)!important;
  border-radius: 4px!important;
  padding: 1rem;
  background: rgba(255,255,255,1);
  color: rgba(0, 0, 0, 0.54);
  margin-top: 1rem;
  margin-bottom: 1rem;

    .list-items li {
      font-size: 14px;
      font-weight: 300;
      color: rgba(0, 0, 0, 0.84);
    }

    .list-items {
      margin-left: 30px;
      margin-top: 10px;
      list-style-type: disc;
      margin-bottom: 10px;
    }
}
</style>
